'use client';

import { useState, useEffect } from 'react';
import { useLocale } from 'next-intl';
import { createClient } from '@/lib/supabase/clients';
import { MobileBottomNav } from './MobileBottomNav';

/**
 * Wrapper for MobileBottomNav that handles auth state on the client
 *
 * Used in layouts where we don't have server-side auth context.
 * Checks authentication status and passes it to MobileBottomNav.
 */
export function MobileBottomNavWrapper() {
  const locale = useLocale();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [email, setEmail] = useState<string | undefined>(undefined);

  useEffect(() => {
    const checkAuth = async () => {
      const supabase = createClient();
      const { data: { session } } = await supabase.auth.getSession();

      if (session?.user) {
        setIsAuthenticated(true);
        setEmail(session.user.email || undefined);
      } else {
        setIsAuthenticated(false);
        setEmail(undefined);
      }
    };

    checkAuth();

    // Listen for auth state changes
    const supabase = createClient();
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setIsAuthenticated(true);
        setEmail(session.user.email || undefined);
      } else {
        setIsAuthenticated(false);
        setEmail(undefined);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <MobileBottomNav
      locale={locale}
      email={email}
      isAuthenticated={isAuthenticated}
    />
  );
}
